import { useEffect, useState } from 'react';
import { getProfessionalProfile } from 'api/newUniprofile';
import { IProfessionalProfile, INewUniprofileResume } from 'types/newUniprofile';
import { getUrlParam } from 'utils/common';
import uniprofileResumeStore from 'store/UniprofileResume';

const DefaultProfessionalProfile: IProfessionalProfile = {
    yearExp: undefined,
    headLine: '',
    intro: '',
    photo: '',
    foreignLanguage: undefined,
    additionalPhotoList: [],
    videoList: [],
};

export const useProfessionalProfile = (
    isAva?: boolean,
    scheduleToken?: string,
): [IProfessionalProfile, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<IProfessionalProfile>(DefaultProfessionalProfile);
    const isAvaParam = isAva || getUrlParam('isAva') === 'true';
    const [getResumeInfo] = uniprofileResumeStore.useStore();

    const getResumeData = () => {
        const resumeData = getResumeInfo('data') as INewUniprofileResume;
        if (resumeData?.professional) {
            setServiceData({
                ...resumeData.professional,
                headLineList: resumeData.headLineList,
                headLineConversationId: resumeData.headLineConversationId,
            });
        }
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getProfessionalProfile(scheduleToken);
            if (!result.error) {
                const data: IProfessionalProfile = result?.data?.data || DefaultProfessionalProfile;
                setServiceData(data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (isAvaParam) {
            getResumeData();
        } else {
            fetchData();
        }
    }, []);

    useEffect(() => {
        if (isAvaParam) {
            getResumeData();
        }
    }, [getResumeInfo('data')]);

    return [serviceData, loading, fetchData];
};
